<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">
        <template v-if="archived"> Archived Products </template>
        <template v-else> Products </template>
      </div>
    </div>

    <div class="tabulka__body">
      <table class="bigTable">
        <thead>
          <td v-if="archived">
            <span>Turn</span>
            <SortButton
              row="turn"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Category</span>
            <SortButton
              :row="
                this.archived
                  ? 'productDetail.productCategory.name'
                  : 'productCategory.name'
              "
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <!-- TODO: radi to podle cisel ID a ne podle skutecnych nazvu -->
            <span>Product name</span>
            <SortButton
              :row="this.archived ? 'productDetail.name' : 'name'"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Quality (Quality affects cost)</span>
            <SortButton
              row="quality"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Cost</span>
            <SortButton
              row="cost"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Selling price</span>
            <SortButton
              row="price"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
        </thead>
        <ProductRow
          v-for="product in sortedData"
          :key="product.id"
          :product="product"
          :archive="archived"
          @delete="deleteProduct(product)"
        />
        <ProductRow
          v-for="(product, index) in tempProducts"
          :key="`TempProduct-${index}`"
          :product="product"
          :archive="false"
          @delete="deleteTempProduct(index)"
        />
      </table>

      <div class="tabulka__middleButton" @click="addProduct()" v-if="!archived">
        Add product
      </div>

    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import ProductRow from "@/components/game/table/ProductRow.vue";

export default {
  name: "Products",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
    ProductRow,
  },
  props: {
    TableWidth: String,
    archived: Boolean,
  },
  data() {
    return {
      currentSortRow: this.archived ? "turn" : "name",
      currentSortDirection: this.archived ? -1 : 1,
      value: 50,
      tempProducts: [],
    };
  },
  computed: {
    ...mapGetters({
      teamProducts: "teamProducts",
      archivedData: "archivedGroupedTeamProducts",
      productCategories: "productCategories",
    }),
    sourceData() {
      return this.archived ? this.archivedData : this.teamProducts;
    },
  },
  methods: {
    deleteProduct() {
      // TODO: vuex action
    },
    deleteTempProduct(index) {
      this.tempProducts.splice(index, 1);
    },
    addProduct() {
      console.log("Test na testu")
       console.log(this.tempProducts)
      this.tempProducts.push({
        name: "",
        productCategoryId: _.get(this.productCategories, "0.id", null),
        quality: 0.5,
        price: null,
      });
    },
  },
};
</script>
